<template>
	<div class="component-container">
		<div class="door-alert">
			<a class="knock" v-show="!knockAnswered" @click="onClick">
				<img class="knock-image" :src="game_config.knock_image" />
				<p>
					Knock-Knock!!!
				</p>
			</a>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'DoorAlert',
	props: ['knockAnswered'],
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
	},
	methods: {
		onClick(e) {
			this.$emit('onClickDoorAlert', e);
		},
	},
};
</script>

<style lang="scss" scoped>
	.component-container{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}
	.door-alert {
		width: 15.8%;
		height: 27.3%;
		top: 23%;
		left: 20%;
		background-color: transparent;
		position: absolute;
		.knock{
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				color: white;
				cursor: pointer;
				padding: 20%;
				transform: scale(0.8);
				opacity: 0;
				animation: knocking 3s infinite 1.5s;
				.knock-image{
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
				p{
					margin: auto;
					text-align: center;
					font-size: 1.5em;
					letter-spacing: 0.06em;
					@include breakpoint(md){
						font-size: 1.1em;
					}
					@include breakpoint(xs){
						font-size: 1em;
					}
				}
		}
	}
	@keyframes knocking {
		0% { color: white; transform: scale(1); opacity: 1;}
		20% { color: white;	transform: scale(1); opacity: 1;}
		21% { color: $red; transform: scale(0.8); opacity: 1;}
		29% { color: $red; transform: scale(0.8); opacity: 1;}
		30% { color: white; transform: scale(1); opacity: 1;}
		50% { color: white; transform: scale(1); opacity: 1;}
		51% { color: $red; transform: scale(0.8); opacity: 1;}
		100% { color: $red; transform: scale(0.8); opacity: 1;}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/DoorAlert.vue